import { red } from '@mui/material/colors'
import colors from './colors'

export function palette(uiMode: 'light' | 'dark') {
  const _colors = colors(uiMode)
  return {
    primary: {
      main: '#ffffff',
      dark: '#ffffff',
      light: '#ffffff',
      contrastText: '#fff',
    },
    info: {
      main: _colors.neutral[500],
      dark: '#202020',
      light: _colors.neutral[500],
    },
    secondary: {
      main: '#161616',
      dark: 'rgba(255, 255, 255, 0.88)',
      contrastText: '#ffffff',
      50: 'rgba(3, 1, 27, 0.8)',
      100: 'rgba(3, 1, 27, 0.5)',
      200: 'rgba(3, 1, 27, 0.05)',
    },
    error: {
      main: red.A400,
    },
    background: {
      paper: _colors.background.body,
      color: _colors.text[0],
      default: '#202020',
    },
    grey: {
      50: 'rgba(255, 255, 255, 0.8)',
      100: 'rgba(255, 255, 255, 0.5)',
      200: 'rgba(255, 255, 255, 0.05)',
      500: 'rgba(255, 255, 255, 0.1)',
      600: 'rgba(255, 255, 255, 0.2)',
    },
  }
}
